import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import costCenterServices from '@src/services/costCenter/costCenter.services';

export const getVehicleCostCenter = createAsyncThunk(
  'getVehicleCostCenter',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customer = await getState().customer;
      const customerId = body?.customerId ?? customer?.selectedCustomer?.customerId;
      const { vouId, costCenterId } = body;
      const data = await costCenterServices.getVehicleCostCenter({
        customerId,
        vouId,
        costCenterId,
      });
      return data.data;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const createVehicleCostCenter = createAsyncThunk(
  'createVehicleCostCenter',
  async ({ department }, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      let request = { ...department };
      if (!request.customerId) {
        request.customerId = customerId;
      }
      const data = await costCenterServices.createVehicleCostCenter({ request });
      return data;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const updateVehicleCostCenter = createAsyncThunk(
  'updateVehicleCostCenter',
  async ({ department }, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      let request = { ...department };
      if (!request.customerId) {
        request.customerId = customerId;
      }
      const data = await costCenterServices.updateVehicleCostCenter({ request });
      return data;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const deleteVehicleCostCenter = createAsyncThunk(
  'deleteVehicleCostCenter',
  async ({ department }, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      let request = { ...department };
      if (!request.customerId) {
        request.customerId = customerId;
      }
      const data = await costCenterServices.deleteVehicleCostCenter({ request });
      return data;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  vehicleCostCenters: [],
  loading: {
    vehicleCostCenters: false,
  },
};

export const costCenterSlice = createSlice({
  name: 'costCenter',
  initialState,
  reducers: {
    resetCurrentLoadCostCenter: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVehicleCostCenter.pending, (state, action) => {
        state.loading.vehicleCostCenters = true;
      })
      .addCase(getVehicleCostCenter.fulfilled, (state, action) => {
        state.loading.vehicleCostCenters = false;

        state.vehicleCostCenters = action?.payload || [];
      })
      .addCase(getVehicleCostCenter.rejected, (state) => {
        state.loading.vehicleCostCenters = false;

        state.vehicleCostCenters = [];
      });
  },
});

export const { resetCurrentLoadCostCenter } = costCenterSlice.actions;
